var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKingpad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 61.05,
    y1: 168.26,
    x2: 62.08,
    y2: 167.85,
    gradientTransform: "translate(-855.37 6172.97) scale(14.09 -36.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe89b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fee091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fdcd76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#fbaf4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb9e34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 63.3,
    y1: 168.2,
    x2: 62.24,
    y2: 167.92,
    gradientTransform: "translate(-795.88 6229.63) scale(14.21 -36.83)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 65.19,
    y1: 171.48,
    x2: 66.19,
    y2: 171.48,
    gradientTransform: "translate(-4867.07 11808.72) scale(74.92 -68.66)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 65.7,
    y1: 155.71,
    x2: 65.7,
    y2: 155.11,
    gradientTransform: "translate(-4940.11 2176.68) scale(76.02 -13.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#371378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a65bf6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29787"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30349",
    className: "cls-2",
    d: "M13.8,96.38h2.73v5.42l4.99-5.42h3.35l-5.07,5.26,5.28,7.14h-3.28l-3.84-5.28-1.43,1.49v3.79h-2.72v-12.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30350",
    className: "cls-2",
    d: "M26.85,96.38h2.73v12.4h-2.73v-12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30351",
    className: "cls-2",
    d: "M32.68,96.38h2.51l5.81,7.63v-7.63h2.69v12.4h-2.32l-6-7.88v7.88h-2.69v-12.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30352",
    className: "cls-2",
    d: "M46.12,102.61v-.04c-.03-3.51,2.8-6.38,6.31-6.41,.06,0,.13,0,.19,0,1.78-.09,3.53,.52,4.87,1.7l-1.72,2.07c-.87-.83-2.04-1.28-3.24-1.26-2.05,.09-3.64,1.81-3.56,3.86v.04c-.12,2.05,1.44,3.8,3.49,3.92,.09,0,.18,0,.26,0,.91,.03,1.81-.23,2.57-.74v-1.77h-2.74v-2.35h5.38v5.38c-1.47,1.27-3.35,1.97-5.29,1.96-3.42,.18-6.33-2.44-6.51-5.86,0-.17-.01-.34,0-.52h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30353",
    className: "cls-2",
    d: "M60.91,96.38h4.5c2.73,0,4.6,1.4,4.6,3.79v.04c0,2.62-2.23,3.95-4.83,3.95h-3.35v4.62h-.92v-12.4h0Zm4.32,6.93c2.3,0,3.86-1.19,3.86-3.05v-.04c0-1.96-1.54-2.99-3.75-2.99h-3.51v6.07h3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30354",
    className: "cls-2",
    d: "M76.2,96.29h.89l5.77,12.48h-1.01l-1.58-3.47h-7.31l-1.58,3.47h-.96l5.77-12.48h0Zm3.68,8.18l-3.26-7.17-3.28,7.17h6.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30355",
    className: "cls-2",
    d: "M85.48,96.38h4.13c3.9,0,6.59,2.67,6.59,6.16v.04c0,3.49-2.69,6.2-6.59,6.2h-4.13v-12.4Zm.92,.85v10.7h3.2c2.9,.21,5.41-1.98,5.62-4.88,.01-.15,.01-.29,.01-.44v-.04c.03-2.93-2.32-5.33-5.26-5.36-.13,0-.25,0-.38,0h-3.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29788"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30356",
    className: "cls-1",
    d: "M28.3,37.85l-11.07-13.17c-.61-.72-1.69-.82-2.41-.21-.41,.34-.63,.86-.61,1.39l1.57,34.71,12.52-22.72h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30357",
    className: "cls-5",
    d: "M93.85,60.89l1.59-35.04c.04-.95-.69-1.75-1.64-1.79-.53-.02-1.05,.2-1.39,.61l-11.18,13.31,12.62,22.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_30358",
    className: "cls-3",
    d: "M92.07,66.83L56.32,1.65c-.46-.83-1.5-1.13-2.33-.68-.29,.16-.52,.39-.68,.68L17.57,66.83c-.46,.83-.15,1.87,.68,2.33,.25,.14,.53,.21,.82,.21l35.75,.06,35.75-.06c.95,0,1.71-.77,1.71-1.71,0-.29-.07-.57-.21-.82h0Zm-37.25-7.9c-6.8,0-12.32-5.51-12.32-12.32s5.51-12.32,12.32-12.32c6.8,0,12.32,5.51,12.32,12.31,0,6.8-5.51,12.32-12.32,12.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30359",
    className: "cls-4",
    d: "M92.19,77.29c.81-.75,.86-2.02,.11-2.84-.38-.41-.91-.64-1.47-.64H18.82c-1.11,0-2.01,.9-2.01,2,0,.56,.23,1.1,.65,1.48l10.27,9.5c.77,.71,1.96,.71,2.72,0l10.14-9.38c.77-.71,1.96-.71,2.72,0l10.14,9.38c.77,.71,1.96,.71,2.72,0l10.14-9.38c.77-.71,1.96-.71,2.72,0l10.14,9.38c.77,.71,1.96,.71,2.72,0l10.28-9.5h0Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKingpad);
export default __webpack_public_path__ + "static/media/kingpad.9aef61a6b43601d5195103c4c56d45d8.svg";
export { ForwardRef as ReactComponent };